import React from 'react';
import { Grid } from '@material-ui/core';

import Product from './Product/Product';
import useStyles from './styles';


const Products = ({ products, onAddToCart }) => {
    const classes = useStyles();

    return (
        <main className={classes.content}>
            <div className={classes.toolbar} />
            <h1 style={{color: '#000a'}}>Art</h1>
            <hr style={{
                marginTop: '-20px',
                marginBottom: '50px',
                color: '#0003',
                backgroundColor: '#0003',
                height: 5,
                width: '100%'
            }} />
            <Grid container justify="center" spacing={4}>
                {products.map((product) => (
                    <Grid item key={product.id} xs={12} sm={6} md={4} lg={3}>
                        <Product product={product} onAddToCart={onAddToCart}/>
                    </Grid>
                ))}
            </Grid>
        </main>
    )
}


export default Products;